import { render, staticRenderFns } from "./VideoManage.vue?vue&type=template&id=6eb610de&scoped=true&"
import script from "./VideoManage.vue?vue&type=script&lang=js&"
export * from "./VideoManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb610de",
  null
  
)

export default component.exports